export const CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM = "CHANGE_DADOS_INICIAIAS_PJ_VALUE_FORM";

export const LOADING_DADOS_INICIAIAS_PJ_CNPJ = "LOADING_DADOS_INICIAIAS_PJ_CNPJ";
export const SET_DADOS_INICIAIAS_PJ_CNPJ = "SET_DADOS_INICIAIAS_PJ_CNPJ";
export const ERROR_DADOS_INICIAIAS_PJ_CNPJ = "ERROR_DADOS_INICIAIAS_PJ_CNPJ";

export const LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE = "LOADING_DADOS_INICIAIAS_PJ_CODIGO_GERENTE";
export const SET_DADOS_INICIAIAS_PJ_CODIGO_GERENTE = "SET_DADOS_INICIAIAS_PJ_CODIGO_GERENTE";
export const ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE = "ERROR_DADOS_INICIAIAS_PJ_CODIGO_GERENTE";

export const LOADING_DADOS_INICIAIAS_PJ_NOME_GERENTE = "LOADING_DADOS_INICIAIAS_PJ_NOME_GERENTE";
export const SET_DADOS_INICIAIAS_PJ_NOME_GERENTE = "SET_DADOS_INICIAIAS_PJ_NOME_GERENTE";
export const ERROR_DADOS_INICIAIAS_PJ_NOME_GERENTE = "ERROR_DADOS_INICIAIAS_PJ_NOME_GERENTE";

export const SET_DADOS_INICIAIAS_PJ_CNAE = "SET_DADOS_INICIAIAS_PJ_CNAE";
export const LOADING_DADOS_INICIAIAS_PJ_CNAE = "LOADING_DADOS_INICIAIAS_PJ_CNAE";
export const ERROR_DADOS_INICIAIAS_PJ_CNAE = "ERROR_DADOS_INICIAIAS_PJ_CNAE";
export const HANDLER_CHANGE_DADOS_INICIAIS_PJ_CNAE = "HANDLER_CHANGE_DADOS_INICIAIS_PJ_CNAE";

export const SET_CODIGO_GERENTE_VIA_LINK_PJ = "SET_CODIGO_GERENTE_VIA_LINK_PJ";
export const SET_ID_DDIPAIS_DADOS_INICIAIS_PJ = "SET_ID_DDIPAIS_DADOS_INICIAIS_PJ";
export const LOADING_DADOS_INICIAIAS_PJ_PAIS = "LOADING_DADOS_INICIAIAS_PJ_PAIS";


